import Auth from './sections/auth'
import { IAPIService } from './types'

class Kit {
  public auth: Auth

  protected service: IAPIService

  public constructor(service: IAPIService) {
    this.service = service

    this.auth = new Auth(service)
  }
}

export default Kit
